import { render, staticRenderFns } from "./order_status.vue?vue&type=template&id=df2448e4&scoped=true&"
import script from "./order_status.vue?vue&type=script&lang=js&"
export * from "./order_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2448e4",
  null
  
)

export default component.exports